import React from 'react';
import { Image } from 'cloudinary-react';

import Container from 'common/container';
import Button from 'common/button';
import Link from 'common/link';

const ReadySetRaise = () => (
    <div className="relative mt-12 lg:mt-32 relative">
        <Container className="max-w-xxxl relative z-10 text-white py-24 lg:py-32 text-center">
            <h2 className="font-black text-28 lg:text-36">
                Discover how to unleash your fundraising potential
            </h2>
            <Button
                to="https://info.pledgeit.org/org-signup?hs_preview=VCHEcwCS-170337018636"
                size="md"
                color="green"
                className="inline-block font-bold text-16 mt-16 mr-12"
                component={Link}
            >
                Get Started
            </Button>
            <Button
                to="/nonprofits/nonprofit-solutions"
                size="md"
                color="white"
                className="inline-block font-bold text-black text-16 mt-16"
                component={Link}
            >
                Learn More
            </Button>
        </Container>
        <Image
            publicId="blog/cta-bg"
            className="absolute z-0 pin w-full h-full object-center object-cover"
            alt=""
        />
    </div>
);

export default ReadySetRaise;
